import { render, staticRenderFns } from "./BnPrimClient.vue?vue&type=template&id=d5495ce0&"
import script from "./BnPrimClient.vue?vue&type=script&lang=js&"
export * from "./BnPrimClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports